import { Component, EventEmitter, Output, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'phoenix-alert-dialog-form',
  template: `
    @if (data.title) {
      <h1 mat-dialog-title>
        <strong>{{ data.title }}</strong>
      </h1>
    }
    <mat-dialog-content class="mat-typography">
      <ng-container *ngTemplateOutlet="data.template"></ng-container>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="w-full flex justify-center m-4">
        <button
          [attr.aria-label]="'DialogCancel'"
          mat-button
          type="button"
          mat-dialog-close
        >
          Cancel
        </button>

        <phoenix-action-button
          [label]="data.btnLabel || 'Save'"
          [loading]="dataLoading"
          (saveSubmit)="submit()"
          [disabled]="
            data.form.invalid || (checkChangesInForm ? !data.form.dirty : false)
          "
        ></phoenix-action-button>
      </div>
    </mat-dialog-actions>
  `,
  styles: [],
  standalone: false,
})
export class DialogFormComponent {
  data = inject(MAT_DIALOG_DATA);
  dataLoading = false;

  @Output() submitButton = new EventEmitter<void>();

  submit() {
    !this.data.autoSaveOff && (this.dataLoading = true);
    this.submitButton.emit();
  }

  get checkChangesInForm() {
    return this.data.checkChangesInForm;
  }
}
